"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateProviders = void 0;
const okta_1 = __importDefault(require("next-auth/providers/okta"));
const generateProviders = ({ clientId, clientSecret, orgDomain, }) => [
    (0, okta_1.default)({
        clientId,
        clientSecret,
        issuer: `https://${orgDomain}/oauth2/default`,
        authorization: {
            params: {
                scope: 'openid offline_access',
            },
        },
    }),
];
exports.generateProviders = generateProviders;
//# sourceMappingURL=providers.js.map